import SearchSolid from '@simplywallst/ui-core/icons/SearchSolid';
import { Button, Box } from '@simplywallst/ui-core';
import { useFlag } from '@/features/unleash';
import useInvestingIdea from '@/pages/CompanyReport/hooks/useInvestingIdea';
import useScreenerLinkInfo from './useScreenerLinkInfo';
import { RouterLink } from '@redux-first-router-link';
import type { GridViewOptions } from '@/pages/CompanyReport/constants/constants';
import { useTracking } from 'react-tracking';
import { getButtonLabelBySubSection } from './utils';

interface Props {
  ideaName: string;
  gridViewOptionId: GridViewOptions;
  subSection: string;
}

export const ScreenerLinkButton = ({
  ideaName,
  gridViewOptionId,
  subSection,
}: Props) => {
  const featureFlag = useFlag({ name: 'mono-in-context-screener' });
  const isExperimentPeerCompanies =
    featureFlag.flagsReady &&
    featureFlag.enabled &&
    featureFlag.variant.name === 'variant';

  const { market, industry } = useScreenerLinkInfo();
  const payload = useInvestingIdea(
    ideaName,
    gridViewOptionId,
    market,
    industry
  );
  const buttonLabel = getButtonLabelBySubSection(subSection);

  const { Track, trackEvent } = useTracking({
    type: 'track',
    subject: subSection,
    modifier: 'screener_link',
  });

  if (!isExperimentPeerCompanies) {
    return null;
  }

  return (
    <Track>
      <Box marginTop="x1">
        {payload && payload.linkToInvestingIdea && (
          <RouterLink
            to={payload.linkToInvestingIdea}
            onClick={() => {
              trackEvent({
                action: 'click',
              });
            }}
            noUnderline
          >
            <Button styleType="loudLarge" alignIcon="left">
              <SearchSolid />
              {buttonLabel}
            </Button>
          </RouterLink>
        )}
      </Box>
    </Track>
  );
};
